/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from 'react';
import { globalAction } from 'common/actions';
import { ERROR_504 } from 'common/config/api';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import UnsavedChangesContext from 'context/UnsavedChangesContext';
import { GenerateReportRequestData } from 'layouts/Main/components/ExcelExportDialog/types';
import ExcelExportService from 'services/excelExport';
import useResponse from './useResponse';

export const useGetInvestorAppReport = () => {
  const service = new ExcelExportService();
  const [, dispatch] = useStore() as unknown as UseStoreValues;
  const { setAction } = useContext(UnsavedChangesContext);

  const { processErrorResponse, successNotification } = useResponse();

  const beginReportProcess = async (reportUUID: string, requestData: GenerateReportRequestData) => {
    if (requestData) {
      dispatch(globalAction.showLoadingProgress(true));

      const defaultErrorMessage = 'An error occurred while exporting the Excel Report';
      try {
        successNotification('Export is being processed');
        await service.beginReportProcess(reportUUID, requestData);
        setAction(false);
      } catch (error: any) {
        if (error.status?.toString() === ERROR_504 || error.crossDomain) {
          // on request timeout we don't show any error message and
          // don't interrupt the pooling process
          setAction(false);
        } else {
          const action = 'Process Excel Report';

          const errors = JSON.parse(error?.response?.text ?? '{}');
          processErrorResponse({
            error,
            defaultErrorMessage,
            action,
          });
          return errors;
        }
      } finally {
        dispatch(globalAction.showLoadingProgress(false));
      }
    }
  };

  return beginReportProcess;
};
